import React, { useState } from 'react';
import axios from 'axios';
import ConfirmDialog from '../../shared/ConfirmDialog';
import CancelButton from '../../shared/CancelButton';
import RequiredMark from '../../shared/RequiredMark';
import '../../shared/StyledInput.css';
import { showMessage } from '../../shared/AppDialogs';

// Reverse Shipment (issue #292), with its required reason. Shared by the
// Shipments list and Pack / Ship's Shipped section. A shipment is never
// deleted: reversing takes its items back off the order as Packed and its
// packages back to closed, ready to change or ship again. onReversed gets
// the reversed shipment.
function ShipmentReverseDialog({ shipment, onClose, onReversed }) {
  const [reason, setReason] = useState('');
  const [reversing, setReversing] = useState(false);
  const orderName = `${shipment.order?.type_label || 'Order'} ${shipment.order?.display_number || ''}`;
  // Reversing an invoiced shipment voids its Invoice (issue #269).
  const invoiceNote = shipment.invoice && !shipment.invoice.voided_at
    ? ` Its Invoice ${shipment.invoice.display_number} is voided; it stays on the Invoices list, marked Void.`
    : '';

  const confirm = async () => {
    if (!reason.trim()) return;
    setReversing(true);
    try {
      const res = await axios.post(`/api/shipments/${shipment.id}/reverse`, { reason: reason.trim() });
      onReversed(res.data.data);
    } catch (err) {
      await showMessage(err.response?.data?.message || 'Failed to reverse shipment', { title: 'Couldn’t Reverse Shipment' });
    }
    setReversing(false);
  };

  return (
    <ConfirmDialog
      open
      onOpenChange={(next) => { if (!next) onClose(); }}
      title={shipment.display_number ? `Reverse Shipment ${shipment.display_number}` : 'Reverse Shipment'}
      description={shipment.lines?.length
        ? `Takes this shipment's items back off ${orderName} as Packed, and its packages back to closed, ready to change or ship again. The shipment stays on the Shipments list, marked reversed.${invoiceNote} This can't be undone.`
        : `This shipment has no items recorded, so ${orderName}'s quantities stay as they are. Its packages go back to closed. The shipment stays on the Shipments list, marked reversed.${invoiceNote} This can't be undone.`}
      footer={(
        <>
          <CancelButton onClick={onClose} disabled={reversing} />
          <button
            type="button"
            onClick={confirm}
            disabled={reversing || !reason.trim()}
            style={{ padding: '8px 14px', border: 'none', color: '#fff', background: reason.trim() ? '#c0392b' : '#c7ccd4', borderRadius: 6, cursor: reason.trim() ? 'pointer' : 'not-allowed', fontSize: 13, fontWeight: 600 }}
          >
            {reversing ? 'Reversing...' : 'Confirm Reverse'}
          </button>
        </>
      )}
    >
      <label style={{ fontSize: 13 }}>
        Reason <RequiredMark />
        <textarea
          className="styled-input"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={3}
          style={{ display: 'block', width: '100%', marginTop: 4, fontSize: 13, resize: 'vertical' }}
        />
      </label>
    </ConfirmDialog>
  );
}

export default ShipmentReverseDialog;
